import React, { useState } from "react";

const UserAvatar = ({ src, name = "", className = "", online }) => {
  const [broken, setBroken] = useState(false);
  const initial = String(name || "U").trim().slice(0, 1).toUpperCase() || "U";
  const showImg = Boolean(src) && !broken;

  return (
    <i className={`${className}${online ? " on" : ""}${showImg ? " has-img" : ""}`} aria-hidden>
      {showImg ? (
        <img src={src} alt="" loading="lazy" onError={() => setBroken(true)} />
      ) : (
        initial
      )}
    </i>
  );
};

export default UserAvatar;
